import useSWR from 'swr';
import { FetchResult, Timesheet } from '../entities';

type Result = FetchResult & { timesheets: Timesheet };

export function useClientTimesheets(id?: string): Result {
  const { data, error, mutate } = useSWR(id ? `/clients/${id}/timesheets` : null);

  return {
    timesheets: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
